module.exports = __webpack_public_path__ + "img/logo_IE.befb5da1.png";